import React, { useEffect, useState } from "react";
import {
  Drawer,
  Button,
  Typography,
  Descriptions,
  Divider,
  Avatar,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import ReservationModal from "./ReservationModal";
import { API_BASE_URL } from "../../../config";

const { Title, Text } = Typography;

const ViewPost = ({ open, onClose, record }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImages] = useState({});
  const token = localStorage.getItem("authToken");

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (record.postedByProfile) {
      fetch(`${API_BASE_URL}${record.postedByProfile}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          setImages((prev) => ({ ...prev, [record.postedById]: url }));
        })
        .catch((err) => {
          console.error(
            `Failed to fetch image for host ${record.postedById}`,
            err
          );
        });
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const getStatusButtonProps = () => {
    const baseProps = {
      className: "w-full font-semibold text-base py-2.5", 
      onClick: showModal,
      block: true, 
    };

    switch (record.status) {
      case "Approved":
        return {
          ...baseProps,
          type: "primary",
          style: { backgroundColor: "#52c41a", borderColor: "#52c41a" }, 
          children: "Approved",
        };
      case "Rejected":
        return {
          ...baseProps,
          type: "primary",
          danger: true,
          children: "Rejected",
        };
      case "Waiting for Approval":
        return {
          ...baseProps,
          type: "default", // Use default and style it
          style: {
            backgroundColor: "#faad14",
            borderColor: "#faad14",
            color: "white",
          }, 
          children: "Waiting for Approval",
        };
      default:
        return {
          ...baseProps,
          type: "dashed",
          children: record.status || "Set Status",
        };
    }
  };

  return (
    <>
      <Drawer
        title={
          <Title level={4} style={{ margin: 0 }}>
            Poster Details
          </Title>
        }
        width={520}
        onClose={onClose}
        open={open}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <div className="space-y-8">
          {" "}
          <Divider className="!my-2" />
          <section>
            <Title level={5} className="mb-4 text-blue-600">
              Customer Information
            </Title>
            <Descriptions bordered column={1} size="small">
              <Descriptions.Item label="Full Name">
                <Text>{record.user || "N/A"}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Phone Number">
                <Text>{record.phoneNumber || "N/A"}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Proof of Identity">
                {record.type_proof_of_identity || "N/A"}
              </Descriptions.Item>
            </Descriptions>
          </section>
          <section>
            <Title level={5} className="mb-4 text-blue-600">
              Host & Property Information
            </Title>
            <div className="flex items-center space-x-4 mb-6 mt-8">
              {record.personImageUrl ? (
                <Avatar size={64} src={image} />
              ) : (
                <Avatar
                  size={64}
                  className="bg-[#55497C]"
                  icon={<UserOutlined />}
                />
              )}
              <div>
                <Title level={5} className="!mb-0">
                  {record.fullName}
                </Title>
                <Text type="secondary">Host</Text>
              </div>
            </div>
            <Descriptions bordered column={1} size="small">
              <Descriptions.Item label="Host Full Name">
                <Text>{record.fullName || "N/A"}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Host Phone No.">
                <Text>{record.postedByPhone || "N/A"}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Host Optional Phone No.">
                {record.postedByOptional || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Property City">
                {record.city || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Property Type">
                {record.typeofHouse || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Specific Address">
                {record.specificAddress || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Price">
                {record.price ? `${record.price}` : "N/A"}
              </Descriptions.Item>
            </Descriptions>
          </section>
          <section>
            <Title level={5} className="mb-3 text-blue-600">
              Approval Status
            </Title>
            <Button {...getStatusButtonProps()} />
          </section>
        </div>
      </Drawer>

      <ReservationModal
        isModalOpen={isModalOpen}
        onClose={onClose}
        record={record}
        title="Reservation Details"
        type="reservation"
        reservationId={record.key}
      />
    </>
  );
};

export default ViewPost;
